const initialState = {
  loading: false,
  allTopic: [],
  selectedStrand: null,
};

const topicReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "LOADING_TOPIC": {
      return {
        ...state,
        loading: actions.loading,
      };
    }
    case "GET_TOPIC_DATA": {
      return {
        ...state,
        loading: actions.loading,
        allTopic: actions.data,
        selectedStrand: actions.id,
      };
    }
    case "CLEAR_DATA": {
      return {
        ...state,
        allTopic: [],
        selectedStrand: null,
      };
    }
    default:
      return state;
  }
};
export default topicReducer;
